import React, { ReactNode } from "react";
import styles from "./Formats.module.css";
import { CurateResource } from "../../../Types/Curate/CurateResource";
import CurateResourceTiles from "./CurateResourceTiles";

type ResourcesProps = {
  resources: CurateResource[];
  resourceClicked?: (resource: CurateResource) => void;
  children: ReactNode;
};

const Resources = ({ resources, resourceClicked, children }: ResourcesProps) => {
  return (
    <div className={styles.container}>
      <div>{children}</div>
      <CurateResourceTiles resources={resources} resourceClicked={resourceClicked} />
    </div>
  );
};

export default React.memo(Resources);
